module.exports = __webpack_public_path__ + "static/img/map-center.d19796e0.svg";